import React, { Component } from 'react'
import {FaCocktail,FaHiking,FaShuttleVan,FaBeer} from 'react-icons/fa'
import Title from './Title'
import '../App.css'

export default class Services extends Component {

    state ={
        services:[
            {
                icon:<FaCocktail/>,
                title:"free cocktails",
                info:"lorem ipsum dolor sit amet consecutor adipicisng elit. Magni,corporis"
            },
            {
                icon:<FaHiking/>,
                title:"Endless Hiking",
                info:"lorem ipsum dolor sit amet consecutor adipicisng elit. Magni,corporis"
            },
            {
                icon:<FaShuttleVan/>,
                title:"Free Shuttle",
                info:"lorem ipsum dolor sit amet consecutor adipicisng elit. Magni,corporis"
            },
            {
                icon:<FaBeer/>,
                title:"Strongest beer",
                info:"lorem ipsum dolor sit amet consecutor adipicisng elit. Magni,corporis"
            },
        ]
    }
    render() {
        return (
            <section className='services'>
            <Title title='services'/>
            <div className='services-center'>
                {
                    this.state.services.map((item,index) =>{
                        return <article key={index} className='service'>
                            <span>{item.icon}</span>
                            <h6>{item.title}</h6>
                            <p>{item.info}</p>
                        </article>
                    })
                }
            </div>

            </section>
        )
    }
}
